import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute , Router} from '@angular/router';
import {FrontUserService} from "../../../core/services/frontUsers.service";
import {FormGroup} from "@angular/forms";
import {CommunicationFormDialogComponent} from "./setting-form/setting-form.component";
import {DataSource} from "@angular/cdk/collections";
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import {CommunicationService} from "../../../core/services/communication.service";
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';
import {FuseUtils} from '../../../core/fuseUtils';
import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {fuseAnimations} from "../../../core/animations";
import {CommunicationCopyFormDialogComponent} from "./setting-form-copy/setting-form.component";
import {TemplatesService} from "../../../core/services/templates.service";
@Component({
    selector: 'templates-page',
    templateUrl: './templates.component.html',
    styleUrls: ['./communications.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class TemplatesComponent implements OnInit
{
  tags: FilesDataSource | null;
  displayedColumns = [ 'type', 'names', 'description', 'sent' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  data;
  ids = '';
  dialogRef: any;
  back = false;

    constructor(private http: HttpClient, public router: Router, private route: ActivatedRoute, private frontUser: FrontUserService, public dialog: MatDialog,
                private templateService: TemplatesService )
    {
      this.ids = this.route.snapshot.queryParamMap.get('ids');
      const type  = this.route.snapshot.queryParamMap.get('type');
    }

  ngOnInit () {
        this.displayedColumns = [ 'name', 'type'];
        this.getDataTemplates();
  }



  getDataTemplates () {
    this.tags = new FilesDataSource(this.templateService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.tags) {
          return;
        }
        this.tags.filter = this.filter.nativeElement.value;
      });
  }

  editType(data) {
    this.dialogRef = this.dialog.open(CommunicationCopyFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw',
      data: {
        action: data.type,
        data: data.data,
        spec: 'template',
        id: data.id,
        description: data.description,
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        this.templateService.getTags().then();
      });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private cantonsService: TemplatesService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.cantonsService.communications;

  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.cantonsService.onCommunicationChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.cantonsService.communications.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'type':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;


      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
